<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <div
        :class="!data.color_theme?.value || data.color_theme?.value === 'blue' ? `bg-theme-500 text-white` : `
          bg-theme-200
        `"
        :style="colorTheme"
        class="max-w-text wysiwyg px-6 py-8 sm:px-8 sm:py-10"
      >
        <div
          v-if="data.text"
          v-animate-children-in-from-bottom
          v-html="data.text"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsMainTextHighlightedFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainTextHighlightedFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)

const colorTheme = useGetColorThemeStylesComponent(props.data.color_theme?.value)
</script>
